import base from './base2.repository';
export default {
    saveClientBroadcastMessage: payload => base.post('client-broadcast-messages', payload),
    getClientBroadcastMessages: (page = 1, filters) => base.get('client-broadcast-messages', {page, ...filters}),

    saveCompanyBroadcastMessage: payload => base.post('company-broadcast-messages', payload)
}